import { PaymentCard, paymentCardSchema } from './schema'

export class BookingStoredCardsServiceFetch {
  async readAll(): Promise<PaymentCard[]> {
    const results: any = await $fetch('/_/fallback/_/users/stored-cards/')
    return this.mappedCards(results.cards)
  }

  private mappedCards(cards): PaymentCard[] {
    return cards.map((card) => {
      return paymentCardSchema.parse({
        brand: card.brand,
        expMonth: card.exp_month.toString(),
        expYear: card.exp_year.toString(),
        id: card.id.toString(),
        last4: card.last4.toString(),
        canDelete: card.can_delete,
      })
    })
  }
}
